import { useState, useEffect } from 'react';

// Matches touch-only devices OR screens smaller than 1024px
const QUERY = '(hover: none) and (pointer: coarse), (max-width: 1023px)';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(QUERY).matches);

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return isMobile;
};
